
<Multiselect v-model="flags" v-bind="multiselectSettings">
    <template #option="props">
        <template v-if="props.option.$isLabel">
            <strong>{{ props.option.$groupLabel }}</strong>
        </template>
        <template v-else>
            <div class="d-flex justify-content-between">
                <span>{{ props.option.name }}</span>
                <span class="text-muted text-right ml-4">{{ props.option.count }}</span>
            </div>
        </template>
    </template>
    <span slot="noOptions" v-if="flags">
        {{ $t("multiselect.noOptionsWithResult") }}
    </span>
    <span slot="noOptions" v-else>
        {{ $t("multiselect.noOptions") }}
    </span>
    <span slot="noResult">
        {{ $t("multiselect.noResults") }}
    </span>
</Multiselect>
